// Review queue (Golden Nominal maintenance): the clusters deduplication could not act on, per
// business area and schema, read from the duplicates service. Items hold ids and versions only;
// the members' values are read through the PII-masked data object GET.
export const GET_REVIEW_QUEUE_ITEMS_REQUEST = "GET_REVIEW_QUEUE_ITEMS_REQUEST";
export const GET_REVIEW_QUEUE_ITEMS_SUCCESS = "GET_REVIEW_QUEUE_ITEMS_SUCCESS";
export const GET_REVIEW_QUEUE_ITEMS_FAILURE = "GET_REVIEW_QUEUE_ITEMS_FAILURE";

export const GET_REVIEW_QUEUE_COUNTS_REQUEST = "GET_REVIEW_QUEUE_COUNTS_REQUEST";
export const GET_REVIEW_QUEUE_COUNTS_SUCCESS = "GET_REVIEW_QUEUE_COUNTS_SUCCESS";
export const GET_REVIEW_QUEUE_COUNTS_FAILURE = "GET_REVIEW_QUEUE_COUNTS_FAILURE";

export const GET_REVIEW_QUEUE_ITEM_REQUEST = "GET_REVIEW_QUEUE_ITEM_REQUEST";
export const GET_REVIEW_QUEUE_ITEM_SUCCESS = "GET_REVIEW_QUEUE_ITEM_SUCCESS";
export const GET_REVIEW_QUEUE_ITEM_FAILURE = "GET_REVIEW_QUEUE_ITEM_FAILURE";
export const CLEAR_REVIEW_QUEUE_ITEM = "CLEAR_REVIEW_QUEUE_ITEM";

export const GET_SCHEMA_JOB_LOCK_REQUEST = "GET_SCHEMA_JOB_LOCK_REQUEST";
export const GET_SCHEMA_JOB_LOCK_SUCCESS = "GET_SCHEMA_JOB_LOCK_SUCCESS";
export const GET_SCHEMA_JOB_LOCK_FAILURE = "GET_SCHEMA_JOB_LOCK_FAILURE";

export const BREAK_SCHEMA_JOB_LOCK_REQUEST = "BREAK_SCHEMA_JOB_LOCK_REQUEST";
export const BREAK_SCHEMA_JOB_LOCK_SUCCESS = "BREAK_SCHEMA_JOB_LOCK_SUCCESS";
export const BREAK_SCHEMA_JOB_LOCK_FAILURE = "BREAK_SCHEMA_JOB_LOCK_FAILURE";
export const CLEAR_SCHEMA_JOB_LOCK_BREAK_RESULT = "CLEAR_SCHEMA_JOB_LOCK_BREAK_RESULT";

export const REVIEW_ITEM_ACTION_REQUEST = "REVIEW_ITEM_ACTION_REQUEST";
export const REVIEW_ITEM_ACTION_SUCCESS = "REVIEW_ITEM_ACTION_SUCCESS";
export const REVIEW_ITEM_ACTION_FAILURE = "REVIEW_ITEM_ACTION_FAILURE";
export const CLEAR_REVIEW_ITEM_ACTION_RESULT = "CLEAR_REVIEW_ITEM_ACTION_RESULT";

export const RESET_REVIEW_QUEUE = "RESET_REVIEW_QUEUE";

// PRE-2837 — the "Subsumed records" view: a schema's records deduplication flagged as subsumed, or
// retired, into a survivor in their own dataset; a steward retires flagged ones or restores one.
export const GET_SUBSUMED_RECORDS_REQUEST = "GET_SUBSUMED_RECORDS_REQUEST";
export const GET_SUBSUMED_RECORDS_SUCCESS = "GET_SUBSUMED_RECORDS_SUCCESS";
export const GET_SUBSUMED_RECORDS_FAILURE = "GET_SUBSUMED_RECORDS_FAILURE";

export const RETIRE_SUBSUMED_REQUEST = "RETIRE_SUBSUMED_REQUEST";
export const RETIRE_SUBSUMED_SUCCESS = "RETIRE_SUBSUMED_SUCCESS";
export const RETIRE_SUBSUMED_FAILURE = "RETIRE_SUBSUMED_FAILURE";

export const RESTORE_SUBSUMED_REQUEST = "RESTORE_SUBSUMED_REQUEST";
export const RESTORE_SUBSUMED_SUCCESS = "RESTORE_SUBSUMED_SUCCESS";
export const RESTORE_SUBSUMED_FAILURE = "RESTORE_SUBSUMED_FAILURE";
export const CLEAR_SUBSUMED_ACTION_RESULT = "CLEAR_SUBSUMED_ACTION_RESULT";

/**
 * @param {string} businessAreaId
 * @param {string} schemaId
 * @param {{ status?: string, type?: string, definitionId?: string }} [filters]
 * @param {string | null} [pageKey]  continues a list
 * @param {boolean} [append]         adds the page to the one shown
 */
export const getReviewQueueItemsRequest = (businessAreaId, schemaId, filters = {}, pageKey = null, append = false) => ({
    type: GET_REVIEW_QUEUE_ITEMS_REQUEST,
    params: { businessAreaId, schemaId, filters, pageKey, append },
});
export const getReviewQueueItemsSuccess = (result, append) => ({ type: GET_REVIEW_QUEUE_ITEMS_SUCCESS, payload: result, append });
export const getReviewQueueItemsFailure = (error) => ({ type: GET_REVIEW_QUEUE_ITEMS_FAILURE, payload: error });

export const getReviewQueueCountsRequest = (businessAreaId, schemaId) => ({ type: GET_REVIEW_QUEUE_COUNTS_REQUEST, params: { businessAreaId, schemaId } });
// The counts carry their schemaId, so a screen never shows another schema's.
export const getReviewQueueCountsSuccess = (counts, schemaId) => ({ type: GET_REVIEW_QUEUE_COUNTS_SUCCESS, payload: { ...counts, schemaId } });
export const getReviewQueueCountsFailure = (error) => ({ type: GET_REVIEW_QUEUE_COUNTS_FAILURE, payload: error });

// The item, then each member's record (null when it no longer exists or could not be read).
export const getReviewQueueItemRequest = (businessAreaId, schemaId, itemId) => ({ type: GET_REVIEW_QUEUE_ITEM_REQUEST, params: { businessAreaId, schemaId, itemId } });
export const getReviewQueueItemSuccess = (item, records) => ({ type: GET_REVIEW_QUEUE_ITEM_SUCCESS, payload: { item, records } });
export const getReviewQueueItemFailure = (error) => ({ type: GET_REVIEW_QUEUE_ITEM_FAILURE, payload: error });
export const clearReviewQueueItem = () => ({ type: CLEAR_REVIEW_QUEUE_ITEM });

// Whether a deduplication, find run or undo holds the schema's lock.
export const getSchemaJobLockRequest = (businessAreaId, schemaId) => ({ type: GET_SCHEMA_JOB_LOCK_REQUEST, params: { businessAreaId, schemaId } });
export const getSchemaJobLockSuccess = (lock) => ({ type: GET_SCHEMA_JOB_LOCK_SUCCESS, payload: lock });
export const getSchemaJobLockFailure = (error) => ({ type: GET_SCHEMA_JOB_LOCK_FAILURE, payload: error });

// Admin action: revokes the lock (only jobId's, when given). The schema is free at availableDate.
export const breakSchemaJobLockRequest = (businessAreaId, schemaId, jobId) => ({ type: BREAK_SCHEMA_JOB_LOCK_REQUEST, params: { businessAreaId, schemaId, jobId } });
export const breakSchemaJobLockSuccess = (result) => ({ type: BREAK_SCHEMA_JOB_LOCK_SUCCESS, payload: result });
export const breakSchemaJobLockFailure = (error) => ({ type: BREAK_SCHEMA_JOB_LOCK_FAILURE, payload: error });
// Once the outcome has been shown, so it is not shown again.
export const clearSchemaJobLockBreakResult = () => ({ type: CLEAR_SCHEMA_JOB_LOCK_BREAK_RESULT });

/**
 * A steward's merge or dismiss of a review item.
 * @param {string} action   "merge" or "dismiss"
 * @param {{ rev: number, reasonCode: string, note?: string, overrides?: object }} request
 */
export const reviewItemActionRequest = (businessAreaId, schemaId, itemId, action, request) => ({
    type: REVIEW_ITEM_ACTION_REQUEST,
    params: { businessAreaId, schemaId, itemId, action, request },
});
export const reviewItemActionSuccess = (action, item) => ({ type: REVIEW_ITEM_ACTION_SUCCESS, payload: { action, item } });
// conflict: the item or its records changed meanwhile (409), so it is read again.
export const reviewItemActionFailure = (action, error, conflict = false) => ({ type: REVIEW_ITEM_ACTION_FAILURE, payload: { action, conflict, ...error } });
// Once the outcome has been shown, so it is not shown again.
export const clearReviewItemActionResult = () => ({ type: CLEAR_REVIEW_ITEM_ACTION_RESULT });

// Before showing another schema's queue: nothing of the previous schema's (its list, item, lock,
// errors or break outcome) stays on screen. The counts carry their schemaId and are kept.
export const resetReviewQueue = () => ({ type: RESET_REVIEW_QUEUE });

/**
 * @param {{ status?: string }} [filters]  status: "SUBSUMED" or "RETIRED" (all when absent)
 * @param {string | null} [pageKey]  continues a list
 * @param {boolean} [append]         adds the page to the one shown
 */
export const getSubsumedRecordsRequest = (businessAreaId, schemaId, filters = {}, pageKey = null, append = false) => ({
    type: GET_SUBSUMED_RECORDS_REQUEST,
    params: { businessAreaId, schemaId, filters, pageKey, append },
});
export const getSubsumedRecordsSuccess = (result, append) => ({ type: GET_SUBSUMED_RECORDS_SUCCESS, payload: result, append });
export const getSubsumedRecordsFailure = (error) => ({ type: GET_SUBSUMED_RECORDS_FAILURE, payload: error });

/** @param {{ dataObjectIds: string[], reasonCode: string, note?: string }} request */
export const retireSubsumedRequest = (businessAreaId, schemaId, request) => ({ type: RETIRE_SUBSUMED_REQUEST, params: { businessAreaId, schemaId, request } });
// result: { results: [{ dataObjectId, outcome }], retired }
export const retireSubsumedSuccess = (result) => ({ type: RETIRE_SUBSUMED_SUCCESS, payload: result });
export const retireSubsumedFailure = (error) => ({ type: RETIRE_SUBSUMED_FAILURE, payload: error });

/** @param {{ reasonCode: string, note?: string }} request */
export const restoreSubsumedRequest = (businessAreaId, schemaId, dataObjectId, request) => ({ type: RESTORE_SUBSUMED_REQUEST, params: { businessAreaId, schemaId, dataObjectId, request } });
export const restoreSubsumedSuccess = (result) => ({ type: RESTORE_SUBSUMED_SUCCESS, payload: result });
export const restoreSubsumedFailure = (dataObjectId, error) => ({ type: RESTORE_SUBSUMED_FAILURE, payload: { dataObjectId, ...error } });
// Once the outcome of a retire or restore has been shown, so it is not shown again.
export const clearSubsumedActionResult = () => ({ type: CLEAR_SUBSUMED_ACTION_RESULT });
